import axios from 'axios';
import { io } from "socket.io-client";
import { SOCKET_EVENTS } from '../common/socket';
import { axiosInstance, baseURL } from './baseApi';
const FileDownload = require('js-file-download');

export const socket = io(baseURL, {
  transports: ['websocket'],
});
socket.on(SOCKET_EVENTS.connect_error, (err) => {
  console.error('[SOCKET] Connect Error:', err.message);
});
socket.on(SOCKET_EVENTS.reconnect, (attemptNumber) => {
  console.warn(`[SOCKET] Reconnected after ${attemptNumber} attempts`);
});
// socket.onAny((eventName, ...args) => {
//   console.log("ANY EVENT:", eventName, args);
// });

export default {
  getActiveWellbores: (params) => axiosInstance.get(`/activewellbores`, { params }),
  postActiveWellbores: (activewellbore) => axiosInstance.post(`/activewellbores`, activewellbore),
  putActiveWellbores: (activewellbore) => axiosInstance.put(`/activewellbores/${activewellbore.id}`, activewellbore),
  deleteActiveWellbores: (activewellboreId) => axiosInstance.delete(`/activewellbores/${activewellboreId}`),

  createUser: (user) => axiosInstance.post(`/auth/signup`, user),
  authUser: (user) => axiosInstance.post(`/auth/signin`, user),
  logout: (userId) => axiosInstance.post(`/auth/logout/${userId}`),

  getUsers: () => axiosInstance.get(`/users`),
  putUsers: (user) => axiosInstance.put(`/users/${user.id}`, user),
  deleteUsers: (userId) => axiosInstance.delete(`/users/${userId}`),

  getPortals: () => axiosInstance.get(`/portals`),
  postPortals: (portal) => axiosInstance.post(`/portals`, portal),
  putPortals: (portal) => axiosInstance.put(`/portals/${portal.id}`, portal),
  deletePortals: (portalId) => axiosInstance.delete(`/portals/${portalId}`),

  getIncidents: (params) => axiosInstance.get(`/incidents`, { params }),
  postIncidents: (incident) => axiosInstance.post(`/incidents`, incident),
  putIncidents: (incident) => axiosInstance.put(`/incidents/${incident.id}`, incident),
  deleteIncidents: (incidentId) => axiosInstance.delete(`/incidents/${incidentId}`),

  getComps: () => axiosInstance.get(`/comps`),
  postComps: (comp) => axiosInstance.post(`/comps`, comp),
  putComps: (comp) => axiosInstance.put(`/comps/${comp.id}`, comp),
  deleteComps: (compId) => axiosInstance.delete(`/comps/${compId}`),

  getStatusWellbores: () => axiosInstance.get(`/wellcheckgtis`),

  getGenerals: () => axiosInstance.get(`/generaldts`),
  putGenerals: (general) => axiosInstance.put(`/generaldts/${general.id}`, general,),

  //print excel
  printExcelWellbores: (settings) => axiosInstance.post(`/activewellbores/excel`, settings, { responseType: 'blob' },
  ).then(response => {
    if (response && !response.error) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
      FileDownload(blob, `Список скважин.xlsx`);
    }
    return response;
  }),

  printExcelIncidents: (settings) => axiosInstance.post(`/incidents/excel`, settings, { responseType: 'blob' },
  ).then(response => {
    if (response && !response.error) {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
      FileDownload(blob, `Список инцидентов.xlsx`);
    }
    return response;
  }),

  checkWellbores: () => axiosInstance.get(`/activewellbores/check`),

  customers: {
    get: () => axiosInstance.get(`/customers`),
    post: (item) => axiosInstance.post(`/customers`, item),
    put: (item) => axiosInstance.put(`/customers/${item.id}`, item),
    delete: (itemId) => axiosInstance.delete(`/customers/${itemId}`),
  },

  getPortalUsers: (params) => axiosInstance.get(`/portalusers`, { params }),
  postPortalUsers: (portaluser) => axiosInstance.post(`/portalusers`, portaluser),
  putPortalUsers: (portaluser) => axiosInstance.put(`/portalusers/${portaluser.id}`, portaluser),
  deletePortalUsers: (portaluserId) => axiosInstance.delete(`/portalusers/${portaluserId}`),
  importPortalUsers: (portalId) => axiosInstance.post(`/portalusers/import/${portalId}`),

  hashtags: {
    get: () => axiosInstance.get(`/hashtags`),
    post: (item) => axiosInstance.post(`/hashtags`, item),
    postMany: (hashtags) => axiosInstance.post(`/hashtags/bulk`, { hashtags }),
    put: (item) => axiosInstance.put(`/hashtags/${item.id}`, item),
    delete: (itemId) => axiosInstance.delete(`/hashtags/${itemId}`),
  },

  documents: {
    get: (params) => axiosInstance.get(`/documents`, { params }),
    getById: (id) => axiosInstance.get(`/documents/${id}`),
    post: (formData, config) => axiosInstance.post(`/documents`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      ...config
    }),
    patch: (id, document, config) => axiosInstance.patch(`/documents/${id}`, document, {
      ...config
    }),
    delete: (id) => axiosInstance.delete(`/documents/${id}`),
    download: (id, config) => axiosInstance.get(`/documents/${id}/download`, { responseType: 'blob', ...config }).then(response => {
      if (response && !response.error) {
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'document';
        if (contentDisposition) {
          const filenameStarMatch = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;\s]+)/i);
          if (filenameStarMatch) {
            filename = decodeURIComponent(filenameStarMatch[1]);
          } else {
            const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
            if (filenameMatch) {
              filename = filenameMatch[1];
            }
          }
        }
        const blob = new Blob([response.data]);
        FileDownload(blob, filename);
      }
      return response;
    }),
    preview: (id, config) => axiosInstance.get(`/documents/${id}/preview`, {
      ...config,
      responseType: 'blob',
    })
      .then(response => {
        return response;
      })
      .catch(async error => {
        if (error.response?.data instanceof Blob) {
          const text = await error.response.data.text();
          const errorData = JSON.parse(text);
          throw {
            ...error,
            response: {
              ...error.response,
              data: errorData,
            }
          }
        }
        throw error;
      })
  },

  agents: {
    get: (params) => axiosInstance.get(`/agents`, { params }),
    check: () => axiosInstance.get(`/agents/check`, ),
    delete: (id) => axiosInstance.delete(`/agents/${id}`),
    createInPortal: (body) => axiosInstance.post(`/agents`,  body ),

    commands: {
      getByAgent: (agent_id, params) => axiosInstance.get(`/agents/${agent_id}/commands`, { params }),
      sync: (agent_id, params) => axiosInstance.get(`/agents/${agent_id}/commands/sync`, { params }),
      create: (params, agent_id, body) => axiosInstance.post(`/agents/${agent_id}/commands`, body, { params } ),
      // delete:  (params) =>axiosInstance.delete(`/agents/${agent_id}/commands/${commandId}`, { params }),
      // deleteAll:  (params) =>axiosInstance.delete(`/agents/commands`, { params }),
      deleteAllByAgent: (params, agent_id) => axiosInstance.delete(`/agents/commands/${agent_id}`, { params }),
    }
  },
};
